import axios from 'axios'

export default {
  namespaced: true,
  state: {
    calls: [],
    fetchingCalls: true
  },
  getters: {
    getCalls(state){ return state.calls }
  },
  mutations: {
    setCalls(state, calls) {
      state.calls = calls
      state.fetchingCalls = false
    }
  },
  actions: {
    fetch({commit}) {
      return new Promise(async (resolve, reject) => {
  
        try {
          let response = await axios.get(`${process.env.VUE_APP_API_ENDPOINT}/calls`, {
            headers: {
              'Authorization': 'Bearer ' + this.state.auth.jwt
            }
          })
  
          if (response.status == 200) {
            commit('setCalls', response.data)
            resolve()
            return;
          }
        } catch (error) {
          reject(error.response.data.message)
          return
        }
  
        reject()
  
      })
    },
  }

}